import { render } from "./TextBookList.vue?vue&type=template&id=de419378"
import script from "./TextBookList.vue?vue&type=script&lang=js"
export * from "./TextBookList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__